import { render, staticRenderFns } from "./MedicineDetail.vue?vue&type=template&id=50e1895d&scoped=true&"
import script from "./MedicineDetail.vue?vue&type=script&lang=js&"
export * from "./MedicineDetail.vue?vue&type=script&lang=js&"
import style0 from "./MedicineDetail.vue?vue&type=style&index=0&id=50e1895d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e1895d",
  null
  
)

export default component.exports